/**
 * Title-case each whitespace-delimited word (first letter upper, rest lower).
 * @param {string} value
 * @returns {string}
 */
export function toTitleCaseWords(value) {
  const s = String(value || "").trim();
  if (!s) return "";
  return s
    .split(/\s+/)
    .map((word) => {
      if (!word.length) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

/**
 * Normalizes verified-business API rows for the offers UI: display title case + A–Z sort.
 * @param {Array<{ businessid: string, name?: string, status?: number }>} list
 * @returns {Array<{ businessid: string, name: string, status?: number }>}
 */
export function normalizeVerifiedBusinessesList(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((b) => ({
      ...b,
      name: toTitleCaseWords(b.name != null ? b.name : ""),
    }))
    .sort((a, b) => (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" }));
}
